import { totalCountType } from '@store/types/totalCountTypes'

export const totalCountInitial: totalCountType = {
  willsCount: 0,
  deathNoticesCount: 0,
  probateNoticesCount: 0,
  loading: false
}
